import React, { useEffect, useState } from 'react'
import api from '../services';
import logo from '../assets/u1.webp';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { IMG_BASE_URL } from '../Helpers';

export default function Announcements() {
    const [announcements, setAnnouncements] = useState([]);

    const fetchAnnouncements = async () => {
        try {
            const data = await api("GET", "announcements");
            setAnnouncements(data);
        } catch (error) {
            console.log(error);
        }
    };
    useEffect(() => {
        fetchAnnouncements();
    }, []);
    return (
        <>
            {announcements.length > 0 && (
                <section className="py-5 bg-white">
                    <div className="container px-5 bg-white">
                        <div className="row gx-5 bg-white">
                            <div className="col-xl-8">
                                <iframe
                                    width="100%"
                                    height="400"
                                    src="https://www.youtube.com/embed/f78S6qdecQ4?autoplay=1&mute=1"
                                    title="Uyirmozhy Introduction Video"
                                    frameBorder="0"
                                    loading="lazy"
                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                    allowFullScreen
                                ></iframe>
                            </div>
                            <div className="col-xl-4">
                                <h2 className="fw-bolder fs-5 mb-4">News</h2>
                                <div className='container bg-white'>
                                    <div className='row'>
                                        <div className="announcements-box bg-white">
                                            <div className="announcements-content">
                                                {[...announcements, ...announcements].map((a, index) => (
                                                    <div className="mt-5 border-bottom pb-3  gx-5" key={index}>
                                                        <div className='col-12'>
                                                            <div className="small text-primary fw-bold">
                                                                <i className="bi bi-calendar3 me-2"></i>
                                                                {new Date(a.release_date).toLocaleDateString('en-US', {
                                                                    month: 'long',
                                                                    day: 'numeric',
                                                                    year: 'numeric'
                                                                })}
                                                            </div>
                                                            <h5 className="fw-bolder">{a.heading}</h5>
                                                        </div>
                                                        <div className='col-12'>
                                                            <img
                                                                src={a.img ? `${IMG_BASE_URL}news/${a.img}` : logo}
                                                                alt="Logo"
                                                                style={{ height: "350px", width: "auto" }}
                                                            />
                                                        </div>
                                                        <div className='col-12'>

                                                            <div className="link-dark mt-2">
                                                                <h6 className="fw-normal">{a.message}</h6>
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </section>
            )}
        </>
    )
}
